<template>
  <el-container>
    <el-main>
      <el-row :gutter="20">
        <el-col v-for="section in records" :key="section.id" :span="8">
          <el-card shadow="never">
            <div slot="header" class="flex">
              <span>{{ section.name }}</span>
              <div class="btns">
                <el-button type="text" @click="onEdit(section)">修改</el-button>
              </div>
            </div>
            <div class="description">{{ section.description }}</div>
            <div class="el-card-footer flex flex-end">
              <el-button size="mini" @click="setMenus(section.id)">配置菜单</el-button>
              <el-button size="mini" @click="setPermissions(section.id)">配置权限</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
    <el-dialog
      v-if="sectionDialogStatus"
      ref="menuFormRef"
      :title="`${modalTit}菜单`"
      :visible.sync="sectionDialogStatus"
      width="600px">
      <el-form ref="formInline" :model="sectionFormData" :rules="sectionRuleValidate" label-width="100px" @submit.native.prevent>
        <el-form-item label="模块类型" prop="type">
          <el-radio-group v-model="sectionFormData.type">
            <el-radio label="基础模块">基础模块</el-radio>
            <el-radio label="商业模块">商业模块</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模块名称" prop="name">
          <el-input v-model="sectionFormData.name"></el-input>
        </el-form-item>
        <el-form-item label="模块标识" prop="url">
          <el-input v-model="sectionFormData.url"></el-input>
        </el-form-item>
        <el-form-item label="模块介绍" prop="description">
          <el-input type="textarea" :rows="4" v-model="sectionFormData.description"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="sectionFormData.sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="模块菜单" :visible.sync="menuDialogStatus" width="600px" top="50px">
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item>
              <el-button type="primary" @click="menuFormStatus = true">添加菜单</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="menus" border row-key="id" default-expand-all height="calc(100vh - 360px)">
        <el-table-column label="菜单" prop="name"></el-table-column>
        <el-table-column label="排序" prop="sort"></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button @click="addMenuChildren(scope.row)">添加子菜单</el-button>
            <el-button @click="onEditMenu(scope.row)">编辑</el-button>
            <el-button type="danger" @click="delMenu(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onCloseMenu">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="menuFormStatus"
      ref="menuFormRef"
      :title="`${modalTit}菜单`"
      :visible.sync="menuFormStatus"
      width="600px">
      <el-form ref="formInline" :model="menuFormData" :rules="menuRuleValidate" label-width="100px" @submit.native.prevent>
        <el-form-item label="名称" prop="name">
          <el-input v-model="menuFormData.name"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="url">
          <el-input v-model="menuFormData.url"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="menuFormData.sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseMenuForm">取 消</el-button>
        <el-button type="primary" @click="onSaveMenuForm">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'Sections',
  data () {
    return {
      records: [],
      permissions: [],
      menus: [],
      modalTit: '添加',
      sectionDialogStatus: false,
      sectionFormData: {
        name: '',
        url: '',
        description: '',
        sort: 1
      },
      sectionRuleValidate: {
        name: [{ required: true, message: '请输入模块名称', trigger: 'blur' }],
        url: [{ required: true, message: '请输入模块标识', trigger: 'blur' }]
      },
      menuDialogStatus: false,
      menuFormStatus: false,
      menuFormData: {
        section_id: null
      },
      menuRuleValidate: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }]
      },
      permissionDialogStatus: false,
      permissionFormStatus: false,
      permissionFormData: {},
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      request.get('sections').then(res => {
        this.records = res.data
      })
    },
    onEdit(row) {
      this.sectionFormData = row
      this.sectionDialogStatus = true
    },
    onClose () {
      this.sectionDialogStatus = false
    },
    onSave() {
      request.put('sections/' + this.sectionFormData.id, this.sectionFormData).then(()=>{
        this.getList()
        this.sectionDialogStatus = false
      })
    },
    setMenus(id) {
      this.menuFormData.section_id = id
      this.menuDialogStatus = true
      this.getSectionMenus(id)
    },
    getSectionMenus(id){
      request.get('/section_menus', {section_id: id}).then(res=>{
        this.menus = res.data
      })
    },
    setPermissions(id) {
      this.permissionFormData.section_id = id
      this.permissionDialogStatus = true
      this.getSectionPermissions(id)
    },
    getSectionPermissions(id){
      request.get('/section_menus', {section_id: id}).then(res=>{
        this.permissions = res.data
      })
    },
    onCloseMenu () {
      this.menuDialogStatus = false
      this.menus = []
    },
    addMenuChildren(row) {
      let parents = []
      if (row.parents) {
        parents = row.parents
        parents.push(row.id)
      } else {
        parents = [row.id]
      }
      this.$set(this.menuFormData, 'parent_id', row.id)
      this.$set(this.menuFormData, 'parents', parents)
      this.modalTit = '添加'
      this.menuFormStatus = true
    },
    onEditMenu(row) {
      this.menuFormData = row
      this.modalTit = '编辑'
      this.menuFormStatus = true
    },
    onCloseMenuForm() {
      this.menuFormStatus = false
      this.menuFormData = {}
    },
    onSaveMenuForm() {
      if(this.menuFormData.id) {
        request.put('/section_menus/' + this.menuFormData.id, this.menuFormData).then(()=>{
          this.getSectionMenus(this.menuFormData.section_id)
          this.menuFormStatus = false
          this.menuFormData = {
            section_id: this.menuFormData.section_id
          }
        })
      } else {
        request.post('/section_menus', this.menuFormData).then(()=>{
          this.getSectionMenus(this.menuFormData.section_id)
          this.menuFormStatus = false
          this.menuFormData = {
            section_id: this.menuFormData.section_id
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-bottom: 20px;
}
.description {
  font-size: 12px;
  height: 34px;
  color: #999;
  margin-bottom: 20px;
}
</style>
